export interface CategoryNode {
  id: string;
  label: string;
  description?: string;
  children?: CategoryNode[];
}

export interface CategoryConfig {
  design: CategoryNode[];
  manufacturing: CategoryNode[];
}

export const categoryConfig: CategoryConfig = {
  design: [
    {
      id: 'concept-design',
      label: 'Concept Design',
      description: 'Initial product concepts and ideation',
    },
    {
      id: '3d-sculpt',
      label: '3D Sculpting',
      description: 'Organic modeling and digital sculpting',
    },
    {
      id: 'cad-design',
      label: 'CAD Design',
      description: 'Precise technical and mechanical design',
    },
    {
      id: 'architectural',
      label: 'Architectural Design',
      description: 'Building and structural design',
    },
  ],
  manufacturing: [
    {
      id: '3d-printing',
      label: '3D Printing',
      description: 'Additive manufacturing processes',
      children: [
        {
          id: 'fdm',
          label: 'FDM',
          description: 'Fused Deposition Modeling',
          children: [
            {
              id: 'pla',
              label: 'PLA',
              description: 'Biodegradable and easy to print',
            },
            {
              id: 'abs',
              label: 'ABS',
              description: 'Durable and heat resistant',
            },
            {
              id: 'petg',
              label: 'PETG',
              description: 'Food safe and chemical resistant',
            },
          ],
        },
        {
          id: 'sla',
          label: 'SLA',
          description: 'Stereolithography',
          children: [
            {
              id: 'standard-resin',
              label: 'Standard Resin',
              description: 'General purpose resin',
            },
            {
              id: 'tough-resin',
              label: 'Tough Resin',
              description: 'Durable and impact resistant',
            },
          ],
        },
      ],
    },
    {
      id: 'cnc',
      label: 'CNC Machining',
      description: 'Computer numerical control cutting',
      children: [
        {
          id: 'aluminum',
          label: 'Aluminum',
          description: 'Lightweight and corrosion resistant',
        },
        {
          id: 'steel',
          label: 'Steel',
          description: 'Strong and durable',
        },
        {
          id: 'plastic',
          label: 'Plastic',
          description: 'Various engineering plastics',
        },
      ],
    },
    {
      id: 'laser-cutting',
      label: 'Laser Cutting',
      description: 'Precision cutting with lasers',
      children: [
        {
          id: 'acrylic',
          label: 'Acrylic',
          description: 'Clear or colored plastic sheets',
        },
        {
          id: 'wood',
          label: 'Wood',
          description: 'Various wood types and thicknesses',
        },
        {
          id: 'metal-sheet',
          label: 'Metal Sheet',
          description: 'Thin metal sheets',
        },
      ],
    },
  ],
};
